import { AttributeCommunity } from './attributecommunity';

export class Attribute {
    public id: number;
    public attributeGroupCommunityId: number;
    public attributeCommunityId: number;
    public attributeCommunity: AttributeCommunity;
    public attributeName: string;
    public attributeGroupLabel: string;
    public manufacturer: string;
    public sku: string;
}

export class JobPlanOptionAttribute extends Attribute {
    public jobPlanOptionId: number;
}

export class JobPlanOptionLocationAttribute extends Attribute {
    public jobPlanOptionLocationId: number;
}